import ReactDOM from 'react-dom/client'
import type { CSSProperties } from 'react'
import { Toaster } from 'sonner'
import AppRouter from './config/routes/router.tsx'
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {setupVersionCheck} from './core/utils/version_check'
import { LanguageProvider } from './i18n/LanguageProvider'
import { i18nReady } from './i18n/config'
import './assets/styles/layout/fonts.css'
import './assets/styles/components/sonner.css'
import './index.css'

setupVersionCheck();

const client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 30,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById("root")!
rootElement.className = 'loading-initial'

// Attend le chargement de la langue courante pour éviter d'afficher le français avant la bascule.
i18nReady.finally(() => {
  ReactDOM.createRoot(rootElement).render(
    <LanguageProvider>
      <QueryClientProvider client={client}>
        <AppRouter />
        <Toaster
          position="top-right"
          closeButton
          gap={10}
          duration={4000}
          toastOptions={{ style: { '--uvibes-duration': '4000ms' } as CSSProperties }}
        />
      </QueryClientProvider>
    </LanguageProvider>
  );

  setTimeout(() => {
    rootElement.classList.remove('loading-initial')
    rootElement.classList.add('loaded')
  }, 200)
})
